<template>
    <x-page title="Edit Observer">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <sms-observer-form
            id="sms-observer-form"
            v-if="Boolean(resource)"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
            :initialFields="resource"
        />
        <template #footer>
            <x-submit-button
                form="sms-observer-form"
                :is-loading="isLoading"
                :disabled="isLoading"
            />
        </template>
    </x-page>
</template>

<script>
import XBackButton from "../../components/XBackButton.vue";
import XPage from "../../components/XPage.vue";
import XSubmitButton from "../../components/XSubmitButton.vue";
import { handleGeneralXhrError, handleValidationXhrError } from "../../helpers";
import SmsObserverForm from "./SmsObserverForm.vue";

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        SmsObserverForm,
    },
    created() {
        this.fetchResource();
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        };
    },
    methods: {
        fetchResource() {
            this.isLoading = true;
            const request = axios
                .get(`/api/sms-observers/${this.$route.params.id}`, {
                    params: {
                        append: ["user_ids", "category_ids"],
                    },
                })
                .then((response) => {
                    this.resource = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleSubmit(fields) {
            this.isLoading = true;
            const request = axios
                .put(`/api/sms-observers/${this.$route.params.id}`, fields)
                .then(() => {
                    this.$notify({
                        type: "success",
                        title: `Berhasil`,
                        text: `${fields.label || "Observer"} updated!`,
                    });
                    this.$router.back();
                });
            return handleValidationXhrError(request, (errors) => {
                this.errors = errors;
                this.isLoading = false;
            });
        },
    },
};
</script>
